<template>
    <div class="vm-goal-group">
        <template v-for="(goal, i) in sum_income_goal_list">
          <goal v-if="i < n1" :goal="goal" :key="goal.goal_id" :user="user" :is_show_sum_info="i == 0"></goal>
        </template>
        <!-- <div v-if="sum_income_goal_list.length > 0" class="line mb24"></div> -->
        <goal v-if="i < n2" v-for="(goal, i) in sponsor_goal_list" :goal="goal" :key="goal.goal_id" :user="user"></goal>
        <goal v-if="i < n3" v-for="(goal, i) in money_goal_list" :goal="goal" :key="goal.goal_id" :user="user"></goal>
        <div v-if="!is_show_all" class="fs20 purple pointer" @click="show_all">更多</div> 
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'goal-group',
    props: {
        list:{
            default(){
                return []
            },
        },
        user:{
            default(){
                return {}
            },
        },
        limit_n:{
            default(){
                return 100000
            },
        },
    },
    components:{
    },
    data() {
      return {
        pre_limit:this.limit_n
      }
    },
    computed:{
        ...mapState('app',[
            'goal_type',
            'goal_status',
            'session_user',
        ]),
        is_show_all(){
          if(this.user && this.user.user_id == '68c30260389511e8979352540025c377'){
            return true
          }
          return this.length_1 + this.length_2 + this.length_3 < this.pre_limit
        },
        length_1(){
          return this.sum_income_goal_list.length * 1
        },
        length_2(){
          return this.sponsor_goal_list.length * 1
        },
        length_3(){
          return this.money_goal_list.length * 1
        },
        n1(){
          return Math.min(this.length_1, this.pre_limit < this.length_1 ?  this.pre_limit : 100000)
        },
        n2(){
          return Math.min(this.length_2, this.pre_limit > this.length_1 ? this.pre_limit - this.length_1 : 0)
        },
        n3(){
          return Math.min(this.length_3, this.pre_limit > this.length_1 + this.length_2 ? this.pre_limit - this.length_1 - this.length_2 : 0)
        },
        sum_income_goal_list(){
            return this.list.filter((v) => v.type == this.goal_type.sum_income)
        },
        sponsor_goal_list(){
            return this.list.filter((v) => v.type == this.goal_type.sponsor).sort((a,b) => a.monthly_fans - b.monthly_fans)
        },
        money_goal_list(){
            return this.list.filter((v) => v.type == this.goal_type.money).sort((a,b) => a.monthly_income - b.monthly_income)
        },
        
    },
    mounted() {

    },
    methods: {
      show_all(){
        this.pre_limit = 10000
      }
    }
};
</script>

<style lang="stylus" scoped>
.vm-goal-group{
    .vm-goal{
        margin-bottom px2rem(24)
        &:last-child{
            margin-bottom 0
        }
    }
}
</style>
